var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("您没有权限访问该页面")])
}
var staticRenderFns = []

export { render, staticRenderFns }